import React from "react";
import "./brand-logo-v1.css";
import { KeaValleyIcon } from "images/image-component";

function BrandLogoV1() {
  return (
    <div className="gp-v1-brand">
      <div className="gp-v1-brand-mark">
        {/* K<span>V</span> */}
        <KeaValleyIcon size={32} />
      </div>
      <div className="gp-v1-brand-name">
        Kea<span>Valley</span>
      </div>
    </div>
  );
}

export default BrandLogoV1;
